import {
  ProducerDto,
  ProducerDtoTypeEnum,
  UpdateAssetDtoProducedByEnum,
} from "generated";

export const getTooltipText = (producerType?: ProducerDtoTypeEnum) => {
  switch (producerType) {
    case "TEAM":
      return "Use this option if the assets in question are created by either a global or by an Ingka team. Examples of these could be Group communications or Home Furnishing & Retail Design.";
    case "MARKET":
      return "Use this option if the assets in question are created locally by either the market or by a local external agency. If the assets are produced by IMC but have been retouched or reworked in any way by a local market, please use this option as well.";
    case "AGENCY":
      return "Use this option if the assets in question are created by an external agency. Choose the correct agency in this drop down and make sure to fill out from where this order came in 'Production ordered by'. If you cannot find the name of the agency in this list, please contact ingka.content.gl@ingka.ikea.com.";
    default:
      return "Please start by filling out Produced by";
  }
};

export const getOptions = (
  producers: ProducerDto[],
  producedBy?: UpdateAssetDtoProducedByEnum,
) => {
  const producerType = getProducerType(producedBy);
  return producers
    .filter((producer) => producer.type === producerType)
    .map(({ id, name }) => ({ label: name, value: String(id) }));
};

export const getProducerType = (
  producedBy?: UpdateAssetDtoProducedByEnum,
): ProducerDtoTypeEnum | undefined => {
  switch (producedBy) {
    case "INTERNAL_LOCAL_PRODUCTION":
      return "MARKET";
    case "AGENCY":
      return "AGENCY";
    default:
      return undefined;
  }
};
